import { action } from "typesafe-actions";
import ActionTypes from "../../constants";

export const tapBtnHelp = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_help",
    customAttributes: {
      product_state: "Callback Requested",
      page: "callback",
      ...customAttributes
    }
  });

export const helpMeFloaterClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "help_me_floater_clicked",
    customAttributes: {
      product_state: "Callback Requested",
      page: "callback",
      ...customAttributes
    }
  });

export const helpMePopupLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "help_me_popup_loaded",
    customAttributes: {
      product_state: "Callback Requested",
      page: "callback",
      ...customAttributes
    }
  });

export const helpMeFormSubmitted = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "help_me_form_submitted",
    customAttributes: {
      product_state: "Callback Requested",
      page: "callback",
      ...customAttributes
    }
  });

export const modalCrossClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "modal_cross_clicked",
    customAttributes: {
      product_state: "Callback Requested",
      page: "callback",
      ...customAttributes
    }
  });

export const mobileNumberEnteredHelpModal = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "mobile_number_entered",
    customAttributes: {
      product_state: "Callback Requested",
      page: "callback",
      ...customAttributes
    }
  });

export const viewAutoCopliotChatbotLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_auto_copliot_chatbot_loaded",
    customAttributes: {
      isViewEvent: true,
      page: "callback",
      ...customAttributes
    }
  });

export const tapBtnCallScheduled = ({
  edata = {},
  odata = {}
}: {
  edata?: Record<string, any>;
  odata?: Record<string, any>;
}) =>
  action(ActionTypes.TRACK, {
    event_name: "action",
    customAttributes: {},
    edata: {
      product: "car",
      action_name: "tap_btn_call_scheduled",
      action_type: "tap_btn",
      techinfo: true,
      product_state: "chatbot_callback",
      ...edata,
      ...(odata.journey && { journey: odata.journey })
    }
  });
